import { Button, Input } from "antd";
import React, { useState } from "react";
import { useMoralis } from "react-moralis";
import { useMoralisDapp } from "providers/MoralisDappProvider/MoralisDappProvider";

function WhiteListNFT() {
    const [addresses, setAddresses] = useState(null);
    const [tokenId, setTokenId] = useState(1);
    const { chainId, marketAddress, contractABI, marketAddressPass, contractABIPass, walletAddress } = useMoralisDapp();
    const contractABIJson = JSON.parse(contractABI);
    const { Moralis } = useMoralis();

    const allowList = "addToAllowlist";


    
    async function submit()
    {
       

        // const addressValues = [];
        // console.log(addressValues);
        // addressValues.push(addresses);

        const addressValues = addresses.split("\n");
        

        console.log(addressValues);
        console.log(tokenId)
            const ops = {
              contractAddress: marketAddress,
              functionName: allowList,
              abi: contractABIJson,
              params: {
                _recipients: addressValues,
                tokenId: tokenId
              },
            };
            try {
              const res = await Moralis.executeFunction(ops);
              console.log("result", res);
            } catch (e) {
              console.log(e);
            }
    }
    return(
        <div>
            <form>
                <textarea cols="50" rows="10" onChange={(e) => setAddresses(e.target.value)}></textarea>
                <Input
                    autoFocus
                    placeholder="Listing Price in MATIC"
                    onChange={(e) => setTokenId(e.target.value)}
                />
                <Button
                    className="primary-button text-white claim-button pass-desc mb-3"
                    onClick={() => submit()}
                    size="large"
                  >
                    CLAIM
                  </Button>
            </form>
        </div>
    )
}

export default WhiteListNFT;